var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 1.80859H9.66406L9.18945 0.478516C9.15666 0.387502 9.09657 0.308831 9.0174 0.253248C8.93822 0.197666 8.84381 0.167883 8.74707 0.167969H4.25293C4.05518 0.167969 3.87793 0.292481 3.81201 0.478516L3.33594 1.80859H1.34375C0.696289 1.80859 0.171875 2.33301 0.171875 2.98047V9.66016C0.171875 10.3076 0.696289 10.832 1.34375 10.832H11.6562C12.3037 10.832 12.8281 10.3076 12.8281 9.66016V2.98047C12.8281 2.33301 12.3037 1.80859 11.6562 1.80859ZM6.5 8.48828C5.20508 8.48828 4.15625 7.43945 4.15625 6.14453C4.15625 4.84961 5.20508 3.80078 6.5 3.80078C7.79492 3.80078 8.84375 4.84961 8.84375 6.14453C8.84375 7.43945 7.79492 8.48828 6.5 8.48828ZM5.09375 6.14453C5.09375 6.51749 5.24191 6.87518 5.50563 7.1389C5.76935 7.40262 6.12704 7.55078 6.5 7.55078C6.87296 7.55078 7.23065 7.40262 7.49437 7.1389C7.75809 6.87518 7.90625 6.51749 7.90625 6.14453C7.90625 5.77157 7.75809 5.41389 7.49437 5.15016C7.23065 4.88644 6.87296 4.73828 6.5 4.73828C6.12704 4.73828 5.76935 4.88644 5.50563 5.15016C5.24191 5.41389 5.09375 5.77157 5.09375 6.14453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCamera);
export default __webpack_public_path__ + "static/media/selectCamera.1a49409504c4290960e1305d305ece8d.svg";
export { ForwardRef as ReactComponent };